import { TReduxActions } from '../../actions';
import { UrlWithBoundsBuilder } from '../../utils/urlWithBoundsBuilder';
import { EResultsActionType } from '../../actions/results';
import { EMapBoundsActionType } from '../../actions/mapBounds';
import { toFiltersUrl } from '../../mappers/queryString';

export function filtersUrlReducer(state: string = '#', action: TReduxActions): string {
  switch (action.type) {
    case EResultsActionType.Succeed:
      if (action.payload.clean) {
        return toFiltersUrl(action.payload.queryString);
      }

      return state;
    case EMapBoundsActionType.Changed:
      return new UrlWithBoundsBuilder(state, action.payload)
        .withCenter()
        .withZoom()
        .build();
    default:
      return state;
  }
}
